<template>
  <v-dialog
    v-model="dialog"
    v-bind="$attrs"
    :fullscreen="fullscreen"
    @input="$emit('change', $event)"
    content-class="overflow-visible"
  >
    <template v-slot:activator="{ on: { click } }">
      <slot name="activator" :click="click" v-if="hasSlotActivator" />
      <custom-btn-icon
        :btn-text="btnText"
        :tooltip-text="btnTooltip"
        :color="btnColor || color"
        :icon="icon"
        :disabled="disabled"
        v-on:click.prevent="click"
        v-else
        @click.prevent="emitPopup"
      />
    </template>
    <custom-dialog
      :color="color"
      :icon="icon"
      :title="title"
      :fullscreen="fullscreen"
      @close="handleCloseClick"
      @fullscreen="handleFullscreenClick"
    >
      <template v-slot:actions>
        <slot name="actions" />
      </template>
      <template v-slot:default>
        <slot />
      </template>
    </custom-dialog>
  </v-dialog>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import CustomDialog from '@/components/dialogs/CustomDialog';
import CustomBtnIcon from '@/components/displays/CustomBtnIcon';

export default {
  name: 'customBtnDialog',
  components: {
    CustomBtnIcon,
    CustomDialog,
  },
  computed: {
    hasSlotActivator() {
      return !!this.$slots.activator || !!this.$scopedSlots.activator;
    },
  },
  props: {
    icon: { type: String, required: false },
    title: { type: String, required: false },
    btnText: { type: String, required: false },
    btnTooltip: { type: String, required: false },
    btnColor: { type: String, required: false },
    color: { type: String, required: false },
    disabled: { type: Boolean, required: false },
  },
  data() {
    return {
      dialog: false,
      fullscreen: false,
    };
  },
  methods: {
    generateMessage,
    handleCloseClick() {
      this.dialog = false;
    },
    handleFullscreenClick() {
      this.fullscreen = !this.fullscreen;
    },
    emitPopup() {
      this.$emit('openPopup');
    },
  },
};
</script>
